export type UploadProgressInput = {
  hasFile: boolean;
  hasDocumentType: boolean;
  hasRegulationScope: boolean;
};

export type UploadProgressStep = {
  id: 'file' | 'documentType' | 'regulationScope';
  complete: boolean;
};

export function getUploadProgress(
  input: UploadProgressInput
): UploadProgressStep[] {
  return [
    { id: 'file', complete: input.hasFile },
    { id: 'documentType', complete: input.hasDocumentType },
    { id: 'regulationScope', complete: input.hasRegulationScope },
  ];
}

export function isUploadReady(input: UploadProgressInput) {
  return getUploadProgress(input).every(step => step.complete);
}
